import client from 'FrontendJsAssets/common/client'
import { tippyAlert } from 'Functions/tippy'

const lang = document.querySelector('html').getAttribute('lang')
let generalError

import(`Locale/${lang}`).then((module) => {
    generalError = module.GeneralError
})

class rPayInvoiceTrigger extends HTMLElement {
    constructor() {
        super()

        this.isLoading = false

        this.handleChange = this.handleChange.bind(this)
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.documentNumber = this.dataset.documentNumber
            this.markUrl = this.dataset.markUrl
            this.unmarkUrl = this.dataset.unmarkUrl
            this.checkbox = this.querySelector('input[type="checkbox"]')

            this.checkbox.addEventListener('change', this.handleChange)
        })
    }

    syncMarkedClass(marked) {
        for (const el of document.querySelectorAll(`[data-document-number="${this.documentNumber}"]`)) {
            el.classList.toggle('is-marked-paid', marked)
        }
    }

    handleLoading(bool) {
        this.isLoading = bool
        this.checkbox.disabled = bool
        this.classList.toggle('is-loading', bool)
    }

    handleAlert(message, type) {
        tippyAlert(this, message, {
            theme: type,
            placement: 'top-start'
        })
    }

    handleChange() {
        if (this.isLoading)
            return

        this.handlePost(this.checkbox.checked)
    }

    handlePost(wantMarked) {
        this.handleLoading(true)

        client.post(wantMarked ? this.markUrl : this.unmarkUrl, { document_number: this.documentNumber })
            .then((response) => {
                const data = response.data

                if (data.status) {
                    this.checkbox.checked = data.marked
                    this.syncMarkedClass(data.marked)
                } else {
                    this.checkbox.checked = !wantMarked
                }

                this.handleAlert(data.message, data.status ? 'success' : 'error')
            })
            .catch((error) => {
                this.checkbox.checked = !wantMarked
                this.handleAlert(generalError, 'error')
                console.error(error)
            })
            .then(() => {
                this.handleLoading(false)
            })
    }

    disconnectedCallback() {
        if (this.checkbox) {
            this.checkbox.removeEventListener('change', this.handleChange)
        }
    }
}

customElements.define('r-pay-invoice-trigger', rPayInvoiceTrigger)

export default rPayInvoiceTrigger
